import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  LinearProgress
} from '@mui/material';
import { styled } from '@mui/system';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    padding: '16px',
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(26, 26, 37, 0.95)' : '#ffffff',
    backdropFilter: 'blur(10px)',
    boxShadow: theme.palette.mode === 'dark' 
      ? '0 8px 32px rgba(0, 0, 0, 0.4)' 
      : '0 8px 32px rgba(0, 0, 0, 0.1)',
    border: `1px solid ${theme.palette.mode === 'dark' 
      ? 'rgba(255, 255, 255, 0.1)' 
      : 'rgba(0, 0, 0, 0.1)'}`,
    maxWidth: '400px',
    width: '90%',
    margin: '16px'
  }
}));

const CreditAlert = ({ open, onClose, requiredCredits, availableCredits }) => {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    if (open) {
      const timer = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(timer);
            onClose();
            return 100;
          }
          return prevProgress + 2;
        });
      }, 50);

      return () => {
        clearInterval(timer);
        setProgress(0);
      };
    }
  }, [open, onClose]);

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="credit-alert-title"
    >
      <DialogTitle id="credit-alert-title" sx={{ 
        textAlign: 'center',
        pb: 1
      }}>
        <Typography variant="h6" component="span" sx={{ 
          fontWeight: 600,
          background: 'linear-gradient(45deg, #8A2BE2, #9370DB)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent'
        }}>
          Yetersiz Kredi
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Typography variant="h3" sx={{ 
            fontSize: '2.5rem',
            fontWeight: 700,
            color: '#8A2BE2',
            mb: 1
          }}>
            {availableCredits}/{requiredCredits}
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
            Bu işlem için {requiredCredits} kredi gerekiyor
          </Typography>
        </Box>
        <LinearProgress 
          variant="determinate" 
          value={progress}
          sx={{
            height: 6,
            borderRadius: 3,
            backgroundColor: 'rgba(138, 43, 226, 0.1)',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#8A2BE2',
              borderRadius: 3
            }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ 
        justifyContent: 'center',
        pt: 2,
        pb: 1
      }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: '#8A2BE2',
            color: 'white',
            borderRadius: '12px',
            padding: '8px 24px',
            '&:hover': {
              backgroundColor: '#7B1FA2'
            }
          }}
        >
          Kredileri Yönet
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default CreditAlert;
